module.exports = __webpack_public_path__ + "img/data-center-bg.e7f353d7.png";